import EqualIcon from "assets/icons/EqualIcon";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import getCurrency from "helpers/currencyHelper";
import { useState } from "react";

export interface PercentPriceInputProps {
  onChange?: ({ price, percent }: { price: number; percent: number }) => void;
  totalPrice: number;
  currency?: string;
}

export default function PercentPriceInput({ onChange, totalPrice, currency }: PercentPriceInputProps) {
  const [price, setPrice] = useState<string | number>(0);
  const [percent, setPercent] = useState<string | number>(0);
  const [percentReRender, setPercentReRender] = useState(0);
  const [priceReRender, setPriceReRender] = useState(0);

  function handlePriceChange(val: number | string) {
    if (typeof val !== "number") return;
    setPrice(val);
    const per = Number(((val * 100) / totalPrice).toFixed(2));
    setPercent(per);
    onChange && onChange({ price: val, percent: per });
    setPercentReRender((x) => x + 1);
  }

  function handlePercentChange(val: number | string) {
    if (typeof val !== "number") return;
    setPercent(val);
    const pri = (val * totalPrice) / 100;
    setPrice(pri);
    onChange && onChange({ price: pri, percent: val });
    setPriceReRender((x) => x + 1);
  }

  return (
    <div className="flex gap-2 p-2 pt-6 items-end flex-wrap">
      <BasicTextInput
        key={"percent" + percentReRender}
        val={percent}
        onChange={handlePercentChange}
        min={0}
        max={100}
        label="درصد"
        type="number"
        style={{ width: 150, padding: "8px 2px" }}
      />
      <EqualIcon color="#95A3B5" style={{ minWidth: 15, maxWidth: 15 }} />
      <BasicTextInput
        key={"price" + priceReRender}
        val={price}
        onChange={handlePriceChange}
        label="مبلغ"
        prefix={<span style={{ color: "#828282" }}>{currency || getCurrency().defCur.en_title}</span>}
        type="price"
      />
    </div>
  );
}
